import overviewJson from '../../demo/fixtures/w2/overview.json'
import { useComplianceCounts, useHealthScore } from '../../demo/selectors'
import { useDemoStore } from '../../demo/store'
import { Badge, Card, CardHead, Icon, RingScore } from '../../ui'
import { healthStatus, healthWeekDelta } from './overview'
import styles from './HealthCard.module.css'

interface HealthItem {
  key: string
  ok: boolean
  value: string
}

interface OverviewFixture {
  health: { items: HealthItem[] }
}

const fixture = overviewJson as unknown as OverviewFixture

export function HealthCard() {
  const score = useHealthScore()
  const compliance = useComplianceCounts()
  const invalidLinks = useDemoStore((state) => state.campaigns.filter((campaign) => campaign.attentionReason === 'product_link_invalid').length)
  const status = healthStatus(score)
  const issueKinds = [compliance.violation, compliance.risk, invalidLinks].filter((count) => count > 0).length
  const weekDelta = healthWeekDelta(score)
  const weekSign = weekDelta > 0 ? '↑' : weekDelta < 0 ? '↓' : ''
  const items = [
    ...fixture.health.items.slice(0, 3),
    {
      key: '政策合规',
      ok: compliance.violation === 0,
      value: compliance.violation > 0 ? `${compliance.violation} 条广告被拒登` : '正常',
    },
  ]

  return (
    <Card data-scope="overview-health">
      <CardHead title="账户健康度" action={<Badge tone={status.tone}>{status.word}</Badge>} />
      <div className={styles.health}>
        <RingScore score={score} />
        <div className={styles.text}>
          <h4>{issueKinds > 0 ? `账户状态${status.word}，还有 ${issueKinds} 类问题可以处理` : '所有问题都处理完了'}</h4>
          <p>
            相比上周 <span className={weekDelta < 0 ? styles.down : styles.up}>{weekSign} {Math.abs(weekDelta)} 分</span>
            {'　·　'}{issueKinds > 0 ? '把待办清空可回到 100 分' : '待办已清空'}
          </p>
        </div>
      </div>
      <div className={styles.items}>
        {items.map((item) => (
          <div className={styles.item} key={item.key}>
            <Icon className={item.ok ? styles.ok : styles.bad} name={item.ok ? 'check-circle' : 'alert'} size={16} strokeWidth={2} />
            <span><b>{item.key}</b>：{item.value}</span>
          </div>
        ))}
      </div>
    </Card>
  )
}
